/* UV Product Recommendations | Horizon 4.1.5
   Adds card-click loading feedback only.
   Recommendation fetching/hydration remains owned by Horizon's native product-recommendations.js. */

const UV_RECOMMENDATIONS_SELECTOR = '.uv-product-recommendations';
const UV_PRODUCT_LINK_SELECTOR = '.uv-product-card__media-link, .uv-product-card__title';

function clearUVProductLoading(root = document) {
  root.querySelectorAll(`${UV_RECOMMENDATIONS_SELECTOR} .resource-list__item.is-product-loading`).forEach((item) => {
    item.classList.remove('is-product-loading');
    item.removeAttribute('aria-busy');
  });
}

if (!window.__uvProductRecommendationsSpinnerBound) {
  window.__uvProductRecommendationsSpinnerBound = true;

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        !(event.target instanceof Element)
      ) {
        return;
      }

      const link = event.target.closest(UV_PRODUCT_LINK_SELECTOR);
      if (!link || !link.closest(UV_RECOMMENDATIONS_SELECTOR)) return;
      if ((link.getAttribute('target') || '').toLowerCase() === '_blank') return;

      const item = link.closest('.resource-list__item');
      if (!item) return;

      clearUVProductLoading();
      item.classList.add('is-product-loading');
      item.setAttribute('aria-busy', 'true');

      window.setTimeout(() => {
        item.classList.remove('is-product-loading');
        item.removeAttribute('aria-busy');
      }, 4000);
    },
    true
  );

  window.addEventListener('pageshow', () => clearUVProductLoading());
}
